module.exports = __webpack_public_path__ + "static/media/61.d05ee74c.svg";